var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 9.66699L3.66667 7.00033M3.66667 7.00033L6.33333 4.33366M3.66667 7.00033H13M9.66667 9.66699V10.3337C9.66667 10.8641 9.45595 11.3728 9.08088 11.7479C8.70581 12.1229 8.1971 12.3337 7.66667 12.3337H3C2.46957 12.3337 1.96086 12.1229 1.58579 11.7479C1.21071 11.3728 1 10.8641 1 10.3337V3.66699C1 3.13656 1.21071 2.62785 1.58579 2.25278C1.96086 1.87771 2.46957 1.66699 3 1.66699H7.66667C8.1971 1.66699 8.70581 1.87771 9.08088 2.25278C9.45595 2.62785 9.66667 3.13656 9.66667 3.66699V4.33366",
    stroke: "#490B2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exit.628660da.svg";
export { ForwardRef as ReactComponent };